/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DataRequest = {
    trace: DataRequest.trace;
    domain: DataRequest.domain;
    graphtype: (0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 0 | 1 | 2 | 3 | 4);
    x_start: number;
    x_length: number;
    segmentUnits: ('ns' | 'm' | 'ft' | 'inches' | 'mm' | 'ns' | 'GHz' | 'THz');
    decimate: DataRequest.decimate;
    spatialRes: number;
    xAx_units: ('ns' | 'm' | 'ft' | 'inches' | 'mm' | 'ns' | 'GHz' | 'THz');
};
export namespace DataRequest {
    export enum trace {
        A = 'A',
        B = 'B',
        C = 'C',
        D = 'D',
        E = 'E',
    }
    export enum domain {
        '_0' = 0,
        '_1' = 1,
    }
    export enum decimate {
        '_0' = 0,
        '_1' = 1,
    }
}

